const url = window.location.origin +"/wp-json/v1/map";

document.addEventListener("DOMContentLoaded", function () {
  fetch(url).then(function(response) {
    if (response.ok) {
      response.json().then(function(data) {
        initializeMap(data.data, data.defaultId);
      });
    } else {
      throw new Error("Something went wrong");
    }
  }).catch(function(error) {
      console.log("Error:", error);
  })
});


function initializeMap(CITIES, defaultId) {
  let root = document.documentElement;
  const map = document.querySelector("#svg-map");
  if (!map) return;
  const segments = map.querySelectorAll(".segment");

  const title = document.querySelector(".map__title");
  const description = document.querySelector(".map__description");
  const surface = document.querySelector(".map__surface");
  const population = document.querySelector(".map__population");
  const cm = document.querySelector(".map__cm");
  const imgBridge = document.getElementById("img-bridge");

  function setTextAndImage(data) {

    result = data.cm.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split('/')[0];

    title.innerText = data.title;
    description.innerHTML = data.description;
    surface.innerText = data.surface;
    population.innerText = data.population;
    cm.innerText = result;
    if(data.cm) {
      cm.href = data.cm;
    }
    if(data.image) {
      imgBridge.src = data.image;
    }
  }

  function getDataById(id) {
    return CITIES.find((c) => c.id === id);
  }

  function getSegmentSettings() {
    return {
      activeColor: "#111",
      activeTagColor: "#fd0",
      segmentColor: "#eee",
      tagColor: "#ccc",
    };
  }

  function setActivePathStyles(nodes, settings) {
    nodes.elem.style.fill = settings.activeColor;
    nodes.rect[0].style.fill = settings.activeTagColor;
  }

  function removeActivePathStyles(nodes, settings) {
    nodes.elem.style.fill = settings.segmentColor;
    nodes.rect[0].style.fill = settings.tagColor;
  }

  function removeActiveStylesFromAllPaths() {
    const activeElements = map.querySelectorAll(".segment.js-active");
    activeElements.forEach(function (elem) {
      const attr = elem.getAttribute("data-target");
      const rect = document.querySelectorAll("rect[data-target=" + attr + "]");
      const nodes = {
        rect,
        elem,
      };
      const settings = getSegmentSettings();
      elem.classList.remove("js-active");
      removeActivePathStyles(nodes, settings);
    });
  }

  function addListeners(nodes, settings) {
    nodes.elem.addEventListener("mouseover", function () {
      setActivePathStyles(nodes, settings);
    });
    nodes.elem.addEventListener("mouseout", function () {
      if (nodes.elem.classList.contains("js-active")) return;
      removeActivePathStyles(nodes, settings);
    });
    nodes.elem.addEventListener("click", function () {
      const attr = nodes.elem.getAttribute("data-target");
      const data = getDataById(attr);
      removeActiveStylesFromAllPaths();
      nodes.elem.classList.add("js-active");
      root.style.setProperty("--tt-active-color", settings.activeColor);
      setTextAndImage(data);
      setActivePathStyles(nodes, settings);
    });
  }

  segments.forEach(function (elem, index) {
    const attr = elem.getAttribute("data-target");
    const rect = document.querySelectorAll("rect[data-target=" + attr + "]");
    const nodes = {
      rect,
      elem,
    };
    const settings = getSegmentSettings(nodes);

    addListeners(nodes, settings);
    if (!index) {
      initDefaultZone(nodes, settings);
    }
  });

  function initDefaultZone(nodes, settings) {
    const data = getDataById(defaultId);
    removeActiveStylesFromAllPaths();
    nodes.elem.classList.add("js-active");
    root.style.setProperty("--tt-active-color", settings.activeColor);
    setTextAndImage(data);
    setActivePathStyles(nodes, settings);
  }
}
